<template>
  <!-- wrapper(s) -->
  <div class="wrapper">
    <Header class="header" :val="headerTitle"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <section class="hr">
          <div class="titArea">
            <h2 class="titH4">결제 수단 정보</h2>
          </div>
          <table class="tableY noLine">
            <colgroup>
              <col style="width:110px" />
              <col style="width:auto" />
            </colgroup>
            <tbody>
              <tr>
                <td class="th">상품</td>
                <td>{{ this.billInfo.productName }}</td>
              </tr>
              <tr>
                <td class="th">주문번호</td>
                <td>{{ this.billInfo.orderId }}</td>
              </tr>
              <!-- 현재 결제 수단이 카드(s) -->
              <tr v-if="this.billInfo.payInfo.card">
                <td class="th">카드사</td>
                <td>{{ this.billInfo.payInfo.cardName }}</td>
              </tr>
              <tr v-if="this.billInfo.payInfo.card">
                <td class="th">카드번호</td>
                <td>{{ this.billInfo.payInfo.maskedCardNumber }}</td>
              </tr>
              <!-- 현재 결제 수단이 카드(e) -->
              <!-- 현재 결제 수단이 CMS(s) -->
              <tr v-if="this.billInfo.payInfo.account">
                <td class="th">은행</td>
                <td>{{ this.billInfo.payInfo.bankName }}</td>
              </tr>
              <tr v-if="this.billInfo.payInfo.account">
                <td class="th">계좌번호</td>
                <td>{{ this.billInfo.payInfo.maskedAccountNumber }}</td>
              </tr>
              <!-- 현재 결제 수단이 CMS(e) -->
              <tr>
                <td class="th">이름</td>
                <td>{{ this.billInfo.payInfo.cardOwner }}</td>
              </tr>
            </tbody>
          </table>
          <!-- table (e) -->
          <div class="txtList_remark">
            본인명의의 결제수단으로 변경 가능합니다.
            <div class="toolTip">
              <em class="tit">결제수단변경 도움말</em>
              법인카드,평생계좌,분실/도난카드로는 변경이 불가하며, 타인명의로 변경을 원하시면 고객센터 1670-0202로 문의해주세요
            </div>
          </div>
        </section>

        <section class="hr">
          <div class="titArea">
            <h2 class="titH4">결제 수단 선택</h2>
          </div>

          <div class="tabWrap">
            <ul class="tabList iptBtn">
              <li class="on" @click="changeCMSType('card')" ref="methodCard"><span class="ico">카드결제</span></li>
              <li @click="changeCMSType('cms')"><span class="ico">CMS자동이체</span></li>
            </ul>
            <div class="tabContents">
              <div class="tabPanel">
                <div class="formArea">
                  <span class="label">카드선택</span>
                  <select v-on:input="changeCard($event.target.value)" v-model="cardName" name="card" class="ipt" title="카드선택">
                    <option value="" disabled="disabled" selected="selected">선택해주세요</option>
                    <option v-for="(cardInfo, index) in rcadCodeList" :key="index" :value="cardInfo.code">{{ cardInfo.codeName }}</option>
                  </select>

                  <span class="label">카드번호</span>
                  <div class="transkey">
                    <div class="setCard">
                      <input
                        type="tel"
                        class="ipt"
                        maxlength="4"
                        title="카드번호 첫번째 4자리"
                        value=""
                        id="cardNum1"
                        v-model="cardNum1"
                        nextTarget="cardNum2"
                        v-onlyNum
                        v-skipOfMax
                      />
                      <span class="sign" aria-hidden="true">-</span>
                      <input
                        type="tel"
                        class="ipt"
                        maxlength="4"
                        title="카드번호 두번째 4자리"
                        value=""
                        id="cardNum2"
                        v-model="cardNum2"
                        nextTarget="cardNum3"
                        v-onlyNum
                        v-skipOfMax
                      />
                      <span class="sign" aria-hidden="true">-</span>
                      <input
                        type="tel"
                        class="ipt"
                        maxlength="4"
                        id="cardNum3"
                        nextTarget="cardNum4"
                        title="카드번호 세번째 4자리"
                        v-onlyNum
                        v-skipOfMax
                        value=""
                        data-tk-kbdType="number"
                        onfocus="mtk.onKeyboard(this); this.scrollIntoView();"
                      />
                      <span class="sign" aria-hidden="true">-</span>
                      <input
                        type="tel"
                        class="ipt"
                        maxlength="4"
                        id="cardNum4"
                        title="카드번호 마지막 4자리"
                        v-onlyNum
                        value=""
                        data-tk-kbdType="number"
                        onfocus="mtk.onKeyboard(this); this.scrollIntoView();"
                      />
                    </div>
                  </div>

                  <span class="label">유효기간</span>
                  <div class="transkey">
                    <div class="setPeriod">
                      <input
                        type="tel"
                        class="ipt"
                        maxlength="2"
                        id="expirdateMM"
                        nextTarget="expirdateYY"
                        title="유효기간 월 2자리"
                        placeholder="MM"
                        v-onlyNum
                        v-skipOfMax
                        data-tk-kbdType="number"
                        onfocus="mtk.onKeyboard(this); this.scrollIntoView();"
                      />
                      <span class="sign" aria-hidden="true">/</span>
                      <input
                        type="tel"
                        class="ipt"
                        maxlength="2"
                        id="expirdateYY"
                        title="유효기간 년 2자리"
                        placeholder="YY"
                        v-onlyNum
                        data-tk-kbdType="number"
                        onfocus="mtk.onKeyboard(this); this.scrollIntoView();"
                      />
                    </div>
                  </div>
                </div>
                <!--<p class="fieldMsg error">카드정보가 올바르지 않습니다 다시 입력해주세요</p>
                <p class="fieldMsg error">이미 등록된 결제 정보입니다. 다시 확인해주세요</p>
                <p class="fieldMsg error">신청자와 카드 명의자가 일치하지 않습니다.</p>-->
              </div>
              <div class="tabPanel">
                <div class="formArea">
                  <span class="label">은행선택</span>
                  <select v-on:input="changeBank($event.target.value)" v-model="bankName" name="bank" class="ipt" title="은행선택">
                    <option value="" disabled="disabled" selected="selected">선택해주세요</option>
                    <option v-for="(bankInfo, index) in rbakCodeList" :key="index" :value="bankInfo.code">{{ bankInfo.codeName }}</option>
                  </select>

                  <span class="label">계좌번호</span>
                  <input
                    type="tel"
                    class="ipt"
                    maxlength="16"
                    id="accountCode"
                    title="계좌번호 입력"
                    placeholder="- 없이 입력해주세요"
                    value=""
                    v-model="accountCode"
                    v-show="!useSecureKeyPad"
                  />
                  <div class="transkey">
                    <input
                      type="tel"
                      class="ipt"
                      id="accountNum"
                      maxlength="16"
                      title="계좌번호 입력"
                      placeholder="- 없이 입력해주세요"
                      value=""
                      data-tk-kbdType="number"
                      onfocus="mtk.onKeyboard(this); this.scrollIntoView();"
                      v-show="useSecureKeyPad"
                    />
                  </div>
                  <span class="singleIpt mt10 ar">
                    <input type="checkbox" class="ipt" name="chk" id="chk2" v-model="useSecureKeyPad" />
                    <label for="chk2">보안키패드로 입력</label>
                  </span>
                  <!--<p class="fieldMsg error">계좌정보가 올바르지 않습니다 다시 입력해주세요</p>
                  <p class="fieldMsg error">이미 등록된 결제 정보입니다. 다시 확인해주세요</p>-->

                  <!--<span class="label">현금영수증</span>
                  <ul class="iptGroup iptBtn">
                    <li>
                      <input type="radio" class="ipt" name="rdo2" id="rdo2_1" value="Y" v-model="issueCashReceipt" />
                      <label for="rdo2_1"><span class="ico">발행</span></label>
                    </li>
                    <li>
                      <input type="radio" class="ipt" name="rdo2" id="rdo2_2" value="N" v-model="issueCashReceipt" />
                      <label for="rdo2_2"><span class="ico">미발행</span></label>
                    </li>
                  </ul>

                  <div>
                    <span class="label">휴대폰번호</span>
                    <input type="tel" class="ipt" title="휴대폰번호 입력" placeholder="- 없이 입력해주세요" value="" v-model="mobile" />
                  </div>-->

                  <!--<p class="fieldMsg error">휴대폰번호를 입력해주세요</p>
                  <p class="fieldMsg error">신청자와 예금주가 일치하지 않습니다.</p>-->
                </div>
              </div>
            </div>
            <p class="txtList_remark">제휴카드 등록 시, 첫 결제에는 실적과 상관없이 할인 혜택을 받을 수 있습니다.</p>
          </div>
        </section>

        <div class="btnArea sticky">
          <button type="button" class="btn_p" @click="changeCmsInfo">변경하기</button>
        </div>
      </div>
      <!-- content(e) -->
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>
    <ChangeCmsPop v-if="changeCmsPop" @close="changeCmsPop = false"></ChangeCmsPop>
    <MessagePop v-if="messagePop" @close="close">
      <p v-html="msg"></p>
    </MessagePop>
  </div>
  <!-- wrapper(e) -->
</template>

<script>
import ChangeCmsPop from './ChangeCmsPop';
import ApiService from '@/common/api.service';
import JwtService from '@/common/jwt.service';
import MessagePop from '@/components/popup/MessagePop';
import { isEmpty } from '@/common/common.function';
import $ from 'jquery';

export default {
  name: 'changePaymentMethod',
  components: { ChangeCmsPop, MessagePop }, // TODO : 결제 정보 파라미터로 받아와야함.
  data: function() {
    return {
      headerTitle: '결제수단변경',
      changeCmsPop: false,
      messagePop: false,
      rcadCodeList: [], // 카드 리스트
      rbakCodeList: [], // 은행 리스트
      bankName: '',
      cardName: '',
      cardNum1: null,
      cardNum2: null,
      cardNum3: null,
      cardNum4: null,
      expirdateMM: null,
      expirdateYY: null,
      cardPasswd: '',
      issueCashReceipt: 'Y', //현금영수증 발행
      cmsType: 'RDUT00CC',
      accountCode: '',
      mobile: '',
      userId: '',
      billInfo: this.$route.params.billInfo,
      useSecureKeyPad: false,
      userInfo: {},
      encCardNumber3: {},
      encCardNumber4: {},
      encCardExpiredYY: {},
      encCardExpiredMM: {},
      encAccountNumber: {},
      bizDate5: '',
      validated: false,
    };
  },
  mounted() {
    let cardCodePrefix = 'RCAD';
    let bankCodePrefix = 'RBAK';
    this.selectCommonCodeList(cardCodePrefix);
    this.selectCommonCodeList(bankCodePrefix);
    if (process.env.NODE_ENV != 'dev') {
      import('@/raon/welcomeTranskey').then(m => {
        m.importCSS();
        m.importJS(0, ['cardNum3', 'cardNum4', 'expirdateMM', 'expirdateYY', 'accountNum']);
      });
    }
    //window.importCSS();
    //window.importJS(0, ['cardNum3', 'cardNum4', 'expirdateMM', 'expirdateYY', 'accountNum']); // 보안키패드
    if (JwtService.getUserInfo()) this.userId = JwtService.getUserInfo().userId;
    this.userInfo = JwtService.getUserInfo();
    this.getBizDate5();
  },
  methods: {
    makeData(id, encrytedYN, plainValue) {
      if (process.env.NODE_ENV == 'dev') return null;
      // eslint-disable-next-line no-undef
      let values = mtk.inputFillEncData(document.getElementById(id));
      let name = document.getElementById(id).name;
      let hidden = values.hidden;
      let hmac = values.hmac;

      // eslint-disable-next-line no-undef
      let keyboardType = transkey[id].keyboard;
      // eslint-disable-next-line no-undef
      let keyIndex = transkey[id].keyIndex;
      // eslint-disable-next-line no-undef
      let fieldType = transkey[id].fieldType;
      // eslint-disable-next-line no-undef
      let inputObjValue = transkey[id].inputObj.value;
      let seedKey = document.getElementById('seedKey').value;
      let initTime = document.getElementById('initTime').value;
      let ExE2E = values.ExE2E;

      let newRaonRequest = {};
      newRaonRequest.id = id;
      newRaonRequest.name = name;
      newRaonRequest.keyboardType = keyboardType;
      newRaonRequest.keyIndex = keyIndex;
      newRaonRequest.fieldType = fieldType;
      newRaonRequest.seedKey = seedKey;
      newRaonRequest.initTime = initTime;
      newRaonRequest.transkey = hidden;
      newRaonRequest.transkey_HM = hmac.toString();
      newRaonRequest.transkey_EXE2E = ExE2E;
      newRaonRequest.plainValue = plainValue;
      newRaonRequest.encrytedYN = encrytedYN;
      newRaonRequest.inputValue = inputObjValue;
      return newRaonRequest;
    },
    change() {
      if (this.cmsType === 'RDUT00CM') {
        //this.changeCmsPop = true;
      }
    },
    changeCard: function(value) {
      this.cardName = value;
    },
    changeBank: function(value) {
      this.bankName = value;
    },
    selectCommonCodeList(codeName) {
      ApiService.service('GET', '/common/code/' + codeName, '')
        .then(({ data }) => {
          for (let code of data.result) {
            if (code.codePrefix === 'RCAD') {
              this.rcadCodeList = code.codeList;
            } else if (code.codePrefix === 'RBAK') {
              this.rbakCodeList = code.codeList;
            }
          }
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    changeCmsInfo() {
      console.log('in');

      this.encCardNumber3 = this.makeData('cardNum3', 'Y');
      this.encCardNumber4 = this.makeData('cardNum4', 'Y');
      this.encCardExpiredYY = this.makeData('expirdateYY', 'Y');
      this.encCardExpiredMM = this.makeData('expirdateMM', 'Y');
      this.encAccountNumber = this.makeData('accountNum', 'Y');

      this.validate();

      console.log('this.validated >> '+this.validated);

      if(this.validated){
        ApiService.service('PUT', '/order/auth/bill', {
        request: {
          checkType: this.cmsType,
          userId: this.userId,
          orderId: this.billInfo.orderId,
          bankCode: this.bankName,
          accountCode: this.accountCode,
          cardCode: this.cardName,
          cardNumber1: this.cardNum1,
          cardNumber2: this.cardNum2,
          encCardNumber3: this.encCardNumber3,
          encCardNumber4: this.encCardNumber4,
          encCardExpireYY: this.encCardExpiredYY,
          encCardExpireMM: this.encCardExpiredMM,
          encAccountNumber: this.encAccountNumber,
          birth: this.userInfo.birth,
          ownerName: this.userInfo.userName,
          useSecureKeyPad: this.useSecureKeyPad ? 'Y' : 'N',
          cashReqYn: this.issueCashReceipt,
          cashNum: this.mobile,
          cardNumber: process.env.NODE_ENV == 'dev' ? this.cardNum1 + this.cardNum2 + document.getElementById('cardNum3').value + document.getElementById('cardNum4').value : '',
          cardExpireDate: process.env.NODE_ENV == 'dev' ? document.getElementById('expirdateMM').value + document.getElementById('expirdateYY').value : '',
        },
        serviceType: 'app',
      })
        .then(({ data }) => {
          if (data.isSucceed) {
            const params = {
              af_premethod: this.billInfo.payInfo.card ? '카드' : 'CMS',
              af_method: this.cmsType == 'RDUT00CM' ? 'CMS' : '카드',
            };
            //const appsFlyerParams = JSON.stringify(params);
            window.appsFlyer('af_change_payment_method', params);
            this.msg =
              this.cmsType == 'RDUT00CM'
                ? 'CMS자동이체 신청시 안전한 금융거래를 위해 자동이체 출금서비스 제공 및 출금에 대한 동의가 필요합니다. 관련하여 전문상담원이 연락 드리겠습니다.'
                : '결제수단이 변경되었습니다.';
            this.messagePop = true;
            this.messageType = 'completed';
          } else {
            this.msg = data.error;
            this.messagePop = true;
            this.messageType = '';
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
          this.categoryList = [];
        });
      }
    },
    changeCMSType(cmsType) {
      if (cmsType === 'card') {
        this.cmsType = 'RDUT00CC';
      } else if (cmsType === 'cms') {
        if (this.billInfo.cmsChginYn == 'Y') {
          this.msg = `결제수단을 CMS로 변경하기 위한 상담예약이 남겨져 있습니다. 상담원이 연락드릴 예정입니다. 남겨주신 계좌가 아닌 다른계좌로 변경을 원하시면 상담원 연락시 말씀해주세요.<br>기타 문의사항은 웰릭스렌탈 고객센터 1670-0202로 문의주시기 바랍니다.`;
          this.messagePop = true;
          this.messageType = 'cmsChecked';
        } else {
          this.cmsType = 'RDUT00CM';
        }
      }
    },
    validate() {
      if (this.billInfo.nextAskDtm < this.bizDate5 ) {
        this.msg = `결제 예정일 5영업일 전에는 결제 수단 변경이 불가능합니다`;
        this.messagePop = true;
        return;
      }

      if (process.env.NODE_ENV != 'dev') {
        
        if (this.cmsType === 'RDUT00CC') {
          if (isEmpty(this.cardName)) {
            this.msg = '카드를 선택해주세요.';
            this.messagePop = true;
            return;
          }
          if (isEmpty(this.cardNum1) || isEmpty(this.cardNum2) || isEmpty(this.encCardNumber3.inputValue) || isEmpty(this.encCardNumber4.inputValue)) {
            this.msg = '카드번호를 확인해주세요.';
            this.messagePop = true;
            return;
          }
          if (isEmpty(this.encCardExpiredYY.inputValue) || isEmpty(this.encCardExpiredMM.inputValue)) {
            this.msg = '유효기간을 확인해주세요.';
            this.messagePop = true;
            return;
          }
        } else {
          if (isEmpty(this.bankName)) {
            this.msg = '은행을 선택해주세요.';
            this.messagePop = true;
            return;
          }
          if ((this.useSecureKeyPad && isEmpty(this.encAccountNumber.inputValue)) || (!this.useSecureKeyPad && isEmpty(this.accountCode))) {
            this.msg = '계좌번호를 입력해주세요.';
            this.messagePop = true;
            return;
          }
          if (this.accountCode.substring(0, 3) == '010' && this.accountCode.length < 12) {
            this.msg = `평생계좌는 사용할 수 없습니다.<br>다른 계좌번호를 입력해주세요.`;
            this.messagePop = true;
            return;
          }
          /*if (this.issueCashReceipt == 'Y' && isEmpty(this.mobile)) {
              this.msg = '현금영수증 번호를 입력해주세요.';
              this.messagePop = true;
              return;
            }*/
          if (this.userInfo != '') {
            this.issueCashReceipt = 'Y';
            this.mobile = this.userInfo.mobile;
          } else {
            this.issueCashReceipt = 'N';
          }
        }
      }

      this.validated = true;
    },
    getBizDate5() {
      ApiService.service('GET', '/common/businessDay/5')
      .then(({ data }) => {
        this.bizDate5 = data.result;
      })
      .catch(({ response }) => {
        console.log(response);
      });
    },
    close() {
      this.messagePop = false;
      if (this.messageType == 'cmsChecked') {
        let card = this.$refs.methodCard;
        $(card)
          .siblings()
          .removeClass('on')
          .attr('aria-selected', false);
        $(card)
          .addClass('on')
          .attr('aria-selected', true);
        $(card)
          .closest('.tabWrap')
          .find('.tabPanel')
          .removeClass('on')
          .attr('aria-hidden', true);
        $(card)
          .closest('.tabWrap')
          .find('#' + $(card).attr('aria-controls'))
          .addClass('on')
          .attr('aria-hidden', false);

        var guideTxt = $(card).text() + ' 탭 내용 시작';
        if (
          $(card)
            .closest('.tabList')
            .next()
            .is('.guideTxt') == false
        ) {
          $(card)
            .closest('.tabList')
            .after('<p class="blind guideTxt">' + guideTxt + '</p>');
        } else {
          $(card)
            .closest('.tabList')
            .next()
            .text(guideTxt);
        }

        $(card)
          .siblings()
          .find('.blind.guideTxt')
          .remove();
        if ($(card).find('.blind.guideTxt').length == 0) {
          $(card).append('<span class="blind guideTxt">선택됨</span>');
        }

        if (
          $(card)
            .closest('.tabList')
            .hasClass('fixed')
        ) {
          var num =
            $(card)
              .closest('.tabWrap')
              .offset().top - 35;
          //console.log(num);
          $('html,body').animate({ scrollTop: num }, 500);
        }
        this.changeCMSType('card');
      } else if (this.messageType == 'completed') {
        this.$router.replace('/myPaymentInfo');
      }
    },
  },
};
</script>
